import { Box } from "@mui/material";
import Chat from "../components/chat";
import ChatbotNavbar from "../components/Navbar/chatbot_navbar";
import useIdleLogout from "../idleLogout";
import useAuthRedirect from "../userAutoRedirect";

export default function Chatbot({ tool }: { tool: string }) {
  useIdleLogout();
  const checkSession = () => {
    return !!sessionStorage.getItem('userDetails');
  };
  const sessionExists = checkSession();
  useAuthRedirect(sessionExists);
  if (!sessionExists) {
    return null;
  }
  return (
    <div className="App">
      <Box display="flex" height="100svh">
        <ChatbotNavbar tool={tool} />
        <Box flex={1} bgcolor={"#f6f9f8"}>
          <Chat tool={tool} />
        </Box>
      </Box>
    </div>
  );
}
